var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.statusInfo)?_c('span',{staticClass:"tag is-medium sc-invoice-audit-tag-status",class:_vm.statusInfo.type},[_c('sc-icon',{attrs:{"icon":_vm.statusInfo.icon}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.statusInfo.text))])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2136d436","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@intelipost-modules/secure-recon/features/invoice-audit/components/sc-invoice-audit-tag-status/ScInvoiceAuditTagStatus.vue
// module id = null
// module chunks = 